module.exports = __webpack_public_path__ + "img/L_9C.505055ac.png";